// Astra · los textos de la web en cuatro idiomas, con `vue-i18n`.
//
// - El **español** va dentro del bundle principal: es la fuente y el respaldo.
// - **Inglés, catalán y francés** se cargan solo si la página está en ese
//   idioma, así que quien entra en español no descarga nada más.
// - Cada idioma es una carpeta de `src/locales/` con un JSON por área. Su
//   `index.js` los junta. Las claves tienen que ser las mismas en los cuatro, y
//   el build lo comprueba (`scripts/i18n-check.mjs`).
//
// ⚠️ Si a un idioma le falta una clave, sale el español, nunca la clave cruda.
import { createI18n } from "vue-i18n";
import es from "@/locales/es";
import { IDIOMA, IDIOMA_BASE } from "./idioma";

export const i18n = createI18n({
  legacy: false,
  locale: IDIOMA_BASE,
  fallbackLocale: IDIOMA_BASE,
  messages: { es },
  // Sin avisos en consola por las claves que caen al español a propósito.
  missingWarn: false,
  fallbackWarn: false,
});

const CARGAS = {
  en: () => import(/* webpackChunkName: "idioma-en" */ "@/locales/en"),
  ca: () => import(/* webpackChunkName: "idioma-ca" */ "@/locales/ca"),
  fr: () => import(/* webpackChunkName: "idioma-fr" */ "@/locales/fr"),
};

/**
 * Pone el idioma de esta carga. Se espera antes de montar la aplicación, para
 * que la primera pintura ya salga en su idioma y no en español un instante.
 *
 * 🔴 Nunca lanza: si el fichero del idioma no llega, la página sale en español.
 */
export async function ponIdioma(idioma = IDIOMA) {
  if (typeof document !== "undefined") document.documentElement.lang = idioma;
  if (idioma === IDIOMA_BASE || !CARGAS[idioma]) return;

  try {
    const modulo = await CARGAS[idioma]();
    i18n.global.setLocaleMessage(idioma, modulo.default);
    i18n.global.locale.value = idioma;
  } catch (e) {
    console.error(`⚠️ i18n: no se pudo cargar «${idioma}», se queda en español ·`, e?.message || e);
  }
}
